/**
 * Die Ortungsgüte einer Position lesbar machen.
 *
 * Encom leitet sie beim Einliefern ab (siehe `encom/src/findmy.ts`) und legt
 * sie unter `meta.ortung` ab. Hier wird daraus ein Etikett samt Farbe und
 * Erklärung — grob geortete Punkte (Funknetz, veraltet) sollen sich sichtbar
 * von echtem GPS unterscheiden.
 */

export type Ortungsguete =
  | "gps" | "wlan" | "netzwerk" | "gerätnah" | "genau" | "grob" | "veraltet" | "unbekannt";

export interface Ortung {
  guete: Ortungsguete;
  grob: boolean;
  typ: string | null;
}

interface OrtungAnzeige {
  etikett: string;
  erklaerung: string;
  /** Ampelfarbe: grün verlässlich, gelb ungefähr, grau veraltet/unbekannt. */
  farbe: string;
}

const ANZEIGE: Record<Ortungsguete, OrtungAnzeige> = {
  gps:       { etikett: "GPS",      erklaerung: "Satellitenortung — präzise",                     farbe: "#16a34a" },
  wlan:      { etikett: "WLAN",     erklaerung: "über bekannte WLANs geortet — meist präzise",    farbe: "#16a34a" },
  gerätnah:  { etikett: "gerätnah", erklaerung: "von einem eigenen Gerät in der Nähe gesehen",    farbe: "#16a34a" },
  genau:     { etikett: "genau",    erklaerung: "präzise geortet",                                 farbe: "#16a34a" },
  netzwerk:  { etikett: "Funknetz", erklaerung: "vom Find-My-Netzwerk fremder Geräte — ungefähr", farbe: "#d97706" },
  grob:      { etikett: "grob",     erklaerung: "nur ungefährer Funkbereich — nicht dort gewesen", farbe: "#d97706" },
  veraltet:  { etikett: "veraltet", erklaerung: "letzte bekannte Position — nicht mehr aktuell",  farbe: "#94a3b8" },
  unbekannt: { etikett: "?",        erklaerung: "Herkunft der Ortung unbekannt",                  farbe: "#94a3b8" },
};

/** Die Ortung aus einem meta-Objekt herausziehen — null, wenn keine da ist. */
export function ortungAus(meta: Record<string, unknown> | null | undefined): Ortung | null {
  const roh = meta?.ortung;
  if (!roh || typeof roh !== "object") return null;
  const o = roh as Partial<Ortung>;
  if (!o.guete) return null;
  return { guete: o.guete, grob: Boolean(o.grob), typ: o.typ ?? null };
}

export function ortungAnzeige(ortung: Ortung | null): OrtungAnzeige | null {
  if (!ortung) return null;
  return ANZEIGE[ortung.guete] ?? ANZEIGE.unbekannt;
}
